module.exports = __webpack_public_path__ + "static/media/payment.a117ec92.png";